export type ProfilePointType = 'symmetric' | 'smooth' | 'corner';

export const PROFILE_POINT_TYPE_LABELS: Record<ProfilePointType, string> = {
  symmetric: 'Symmetric',
  smooth: 'Smooth',
  corner: 'Corner',
};

export const PROFILE_POINT_TYPE_COLORS: Record<ProfilePointType, string> = {
  symmetric: '#c4b5fd',
  smooth: '#67e8f9',
  corner: '#fbbf24',
};
